import React from 'react'
import { 
    ArtefactsContainer, 
    ArtefactCard,
    ArtefactWrapper,
    ArtefactsHeading,
    ArtefactsHeading1,
    Title, 
    Desc, 
    ArtefactInfo,
    ArtefactImg
} from './BidayuhArtefacts';

import '../../../../App.css';
import {useState} from 'react'; 
import {AiOutlineMan, AiOutlineWoman} from 'react-icons/ai';
import {AiOutlineSearch} from 'react-icons/ai';
import {IbanMenCostList, IbanWomenCostList } from './data';


const IbanCostumes = (props)=> {

    const [searchTerm, setSearchTerm] = useState ("");

    return (
            <ArtefactsContainer> 
            
                <ArtefactsHeading> Iban Traditional Costumes </ArtefactsHeading>
                        <label className = "label"> <AiOutlineSearch/> Filter Arterfect </label>
                        <input className = "searchbox"
                            type = "text"
                            placeholder= " Unwrap your heritage " 
                            onChange = {(event) => {
                                setSearchTerm(event.target.value);
                            }}
                        />
                   
                    <ArtefactsHeading1> 
                        <AiOutlineMan/> Men Traditional Costumes
                    </ArtefactsHeading1>

                    <ArtefactWrapper> 
                        {IbanMenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
                        
                    <ArtefactsHeading1> 
                        <AiOutlineWoman/> Women Traditional Costumes 
                    </ArtefactsHeading1>
                    <ArtefactWrapper> 
                      {IbanWomenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>

            </ArtefactsContainer>
    );
};

export default IbanCostumes
